export const DRAGON_TILES_LAYOUT_VARIANTS = {
  1: [1, 0, 0, 0],
  2: [0, 2, 0, 0],
  3: [3, 0, 0, 0],
  4: [1, 2, 1, 0],
  5: [3, 2, 0, 0],
  6: [3, 2, 1, 0],
  7: [5, 2, 0, 0],
  8: [5, 2, 1, 0],
  9: [5, 4, 0, 0],
  10: [5, 4, 1, 0],
  11: [5, 6, 0, 0],
  12: [5, 6, 1, 0],
  13: [5, 6, 2, 0],
  14: [5, 6, 3, 0],
  15: [5, 6, 4, 0],
  16: [5, 6, 5, 0],
  17: [5, 6, 4, 2],
  18: [5, 6, 3, 4],
  19: [5, 6, 5, 3],
  20: [5, 6, 5, 4],
};
